import { render, staticRenderFns } from "./AvatarSquare.vue?vue&type=template&id=1e9a7ac1&"
import script from "./AvatarSquare.vue?vue&type=script&lang=js&"
export * from "./AvatarSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports